import React from "react";
import OfferModalComponent from "./OfferModalComponent";
import { useNavigate, useLocation } from "react-router";
import { ROUTES } from "@Src/constants/Routes";
import { selectors } from "@ReduxStore/reducers";
import { useSelector } from "react-redux";
import { matchStoreToAttraction } from "@Src/utils/themePark.utils";

function OfferModal(props) {
  const { store_key } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const storeMappings = useSelector(selectors.getStoreMappings);
  const [showOffer, setShowOffer] = React.useState(false);

  const checkStore = React.useCallback(
    (storeKey) => {
      const isAttraction = matchStoreToAttraction(storeKey, null, storeMappings);
      if (isAttraction) {
        const route = isAttraction.retailer_id ? ROUTES.RETAILER_PATH : ROUTES.PARKS_PATH;
        navigate(route, {
          state: isAttraction,
        });
        props.closeModal();
      } else {
        setShowOffer(true);
      }
    },
    [storeMappings, navigate, props],
  );

  React.useEffect(() => {
    if (store_key) {
      checkStore(store_key);
    }
  }, [store_key, checkStore]);

  if (!showOffer) return null;
  return <OfferModalComponent {...props} navigate={navigate} routerLocation={location} />;
}

export default OfferModal;
